import React, { Component } from 'react';
import { SummaryList } from '@eg/elements/SummaryList';
import { Button } from '@eg/elements/Button';
import { CheckIcon } from '@eg/elements/Icons/CheckIcon';
import { PremiumBox } from '@eg/elements/PremiumBox';
import { Price } from '@eg/elements/Price';
import { EditIcon } from '@eg/elements/Icons/EditIcon';
import { StepButton } from '@eg/elements/StepButton';

import CheckoutNavigation from '../../../components/shared/checkout-navigation/CheckoutNavigation';
import PrivacyInformation from '../../../components/shared/privacy-information/PrivacyInformation';
import FirstInformation from '../../../components/shared/first-information/FirstInformation';

import { clearSessionStorage } from '../../common/SessionHandler';

import "./CheckoutSummary.scss";

import axios from 'axios';

class CheckoutSummary extends Component {
  constructor(props) {
    super(props);

    this.state = {
      nonce: '',
      salutation: '',
      firstName: '',
      lastName: '',
      streetName: '',
      houseNumber: '',
      postcode: '',
      city: '',
      birthday: '',
      email: '',
      phoneNumber: '-',
      paymentId: '',
      payerId: '',
      infoAccepted: false,
      submitDisabled:false,
    };

    this.handleClick = this.handleClick.bind(this);
    this.changeInput = this.changeInput.bind(this);
    this.handleDownload = this.handleDownload.bind(this);
  }

  componentDidMount () {
    var payID = this.getUrlData("paymentId");

    this.setState({paymentId: payID});
    axios.get(process.env.REACT_APP_BACKEND_URL +'/csppayments/'+ payID).then((res) => {
      this.setState({
        salutation: res.data.salutation,
        firstName: res.data.firstName,
        lastName: res.data.lastName,
        streetName: res.data.street,
        houseNumber: res.data.houseNumber,
        postcode: res.data.zip,
        city: res.data.city,
        birthday: this.putInFormat(res.data.dateOfBirth),
        email: res.data.email,
        phoneNumber: res.data.phoneNumber,
      });

      if(res.data.phoneNumber === '') {
        this.setState({phoneNumber: '-'});
      }

      // Fill session storage with data from backend
      sessionStorage.setItem('paymentId', payID);
      sessionStorage.setItem('insuranceStartDate', res.data.startDateForPolicy);

      if(sessionStorage.getItem('timestamp') === null) {
        sessionStorage.setItem('timestamp', new Date());
      }

      axios.post(process.env.REACT_APP_BACKEND_URL + '/nonce', {'nonceType': 'EXECUTE'}).then((res) => {
        this.setState({nonce: res.data.nonce});
      }).catch((error) => {
        this.errorHandler(error);
      });

    }).catch((error) => {
      this.errorHandler(error);
    });
  }

  getUrlData = (variable) => {
    var url = window.location.search.substring(1);
    var data = url.split("&");

    for (var i=0; i<data.length; i++) {
      var pair = data[i].split("=");
      if(pair[0] ===  variable) {
        return pair[1];
      }
    }
  }

  putInFormat = (date) =>{
    var dateArray = date.split("-");
    return(dateArray[2] + "." + dateArray[1] + "." + dateArray[0]);
  }

  checkTimer = () => {
    var now = new Date();
    var start = new Date (sessionStorage.getItem('timestamp'));
    var diff =(now.getTime() - start.getTime()) / 1000;
    var res;

    diff /= 60;
    res = Math.abs(Math.round(diff));

    return (res < 30);
  }

  errorHandler = (error) => {
    if(error.response === undefined) {
      clearSessionStorage();
      this.props.history.push("/internet-schutzbrief/404");
    } else if(error.response.status === 400 ) {
      clearSessionStorage();
      this.props.history.push("/internet-schutzbrief/technischer-fehler");
    } else if (error.response.status ===  406 || error.response.status === 500) {
      this.props.history.push("/internet-schutzbrief/anfrage-fehlgeschlagen");
    } else if (error.response.status ===  404) {
      clearSessionStorage();
      this.props.history.push("/internet-schutzbrief/404");
    } else if (error.response.status === 403) {
      this.props.history.push("/internet-schutzbrief/403");
    } else {
      clearSessionStorage();
      this.props.history.push("/internet-schutzbrief/404");
    }

    window.scrollTo(0, 0);
  }

  changeInput() {
    this.props.history.push("/internet-schutzbrief/persoenliches")
    window.scrollTo(0, 0);
  }

  handleDownload() {
    this.setState({infoAccepted: true});
  }

  handleClick() {
    var payer = this.getUrlData("PayerID");
    var payID = this.getUrlData("paymentId");

    this.setState({submitDisabled: true});
    this.setState({payerId: payer});
    var paymentData = {
      "nonce": this.state.nonce,
      "payerId": payer,
      "infoAccepted": this.state.infoAccepted
    };

    if(this.state.infoAccepted === true && this.checkTimer()){
      axios.put(process.env.REACT_APP_BACKEND_URL +'/csppayments/'+ payID +'/execute', paymentData).then((res) => {
        this.setState({submitDisabled: false});
        this.props.history.push("/internet-schutzbrief/info");
        clearSessionStorage();

        window.scrollTo(0, 0);
      }).catch((error) => {
        this.errorHandler(error);
        this.setState({submitDisabled: false})
      });
    } else if (!this.checkTimer()) {
      this.props.history.push("/internet-schutzbrief/tarifdaten");
      clearSessionStorage();

      window.scrollTo(0, 0);
    } else {
      this.setState({submitDisabled: false});
    }
  }

  render() {
    return(
      <div className="esc_container outerContainer">
        <div className="esc_container esc_container--l">
          <CheckoutNavigation step="4" />
          <PrivacyInformation />
          <div className="CheckoutSummary">
            <hr />
              <div className="esc_container">
                <h2>Tarifdaten und Beitrag</h2>
                <p>INTERNET-SCHUTZBRIEF nach Tarif ISB Gesamtversicherungssumme: 15.000 €</p>
                <h4>Versicherungsumfang:</h4>
                <ul id="checkoutSummaryList">
                  <li><CheckIcon width={20} height={20}/> Weltweiter Schutz vor finanziellen Verlusten bei widerrechtlicher Verwendung von Kunden-/Kontodaten</li>
                  <ul id="checkoutSummaryList">
                    <li><CheckIcon  width={20} height={20} /> z. B. durch Phishing, Pharming, Skimming und Hacking</li>
                    <li><CheckIcon width={20} height={20} /> bei bargeldlosen Bezahlvorgängen</li>
                    <li><CheckIcon width={20} height={20} /> beim Online- und E-Mail-Banking</li>
                    <li><CheckIcon width={20} height={20} /> bei Bonussystemen und Onlinegutscheinen (max. 500 €)</li>
                  </ul>
                  <li><CheckIcon width={20} height={20} /> Nichtlieferung Online-Shopping (max. 3.000 €)</li>
                </ul>
                <div className="esc_box">Laufzeit: 1 Jahr</div>
              </div>
              <PremiumBox label=<strong>Einmalbeitrag:</strong> price={<Price value={6.90}/>} />
              <hr id="hr_style" />
              <h2>Persönliche Daten der zu versichernden Person</h2>
              <small>Bitte überprüfen Sie Ihre Angaben auf Richtigkeit und Vollständigkeit</small>
              <SummaryList>
                <dt>Anrede</dt>
                <dd>{this.state.salutation}</dd>
                <dt>Vorname</dt>
                <dd>{this.state.firstName}</dd>
                <dt>Nachname</dt>
                <dd>{this.state.lastName}</dd>
                <dt>Geburtsdatum</dt>
                <dd>{this.state.birthday}</dd>
                <dt>Anschrift</dt>
                <dd>{this.state.streetName} {this.state.houseNumber}</dd>
                <dd>{this.state.postcode} {this.state.city}</dd>
                <dt>E-Mail</dt>
                <dd>{this.state.email}</dd>
                <dt>Telefonnummer</dt>
                <dd>{this.state.phoneNumber}</dd>
                <dd><p><Button onClick={this.changeInput} id="changeInputButton"  variant="text-link" iconLeft={<EditIcon/>} style={{ float: "left" }}>Angaben ändern</Button></p></dd>
              </SummaryList>
              <hr />
              <div>
                <h1>Zahlungsweise</h1>
                <p>PayPal</p>
              </div>
              <hr />
              <h1>Vertragsunterlagen</h1>
              Bitte speichern Sie vor dem Online-Abschluss die Vertragsunterlagen und Informationen als PDF.
              <div className="DownloadSection" id="downloadSection">
                <a href={process.env.PUBLIC_URL +'/statics/Vertragsunterlagen-ISB.pdf'} id="download-button" download="Vertragsunterlagen.pdf" target="_blank" rel="noopener noreferrer" onClick={this.handleDownload}>
                  <StepButton
                    text="Herunterladen"
                    note="Bitte laden Sie folgende für die Versicherung gültigen Dokumente herunter. Andernfalls ist ein Abschluss der Versicherung nicht möglich"
                    step="1"
                    variant="primary"
                    onClick={this.handleDownload}
                  />
                </a>
            </div>
            <div className="esc_container" id="submit-contract">
              <StepButton
                text="Online abschließen"
                subText="zahlungspflichtiger Vertrag"
                note="Bei Vertragsabschluss fallen für Sie keine weiteren Nebenkosten an"
                step="2"
                variant="primary"
                onClick={this.handleClick}
                disabled={!this.state.infoAccepted}
                loading= {this.state.submitDisabled}
              />
            </div>
            <FirstInformation />
          </div>
        </div>
      </div>
    )
  }
}

export default CheckoutSummary;
